import { log } from "~features/seated-reservation/helpers/stateLogger";
import { resetState } from "../non-seated-reservation-store";

export function resetInitialState() {
  log("resetInitialState");

  resetState();
}
